import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

const BASE_URL = `${BASE_API()}/scm/distributer-point`

// 积分获得明细查询
export function fetchDistributerPointEarnPage(data) {
  return request({
    url: `${BASE_URL}/earn/page`,
    method: 'post',
    data
  })
}

// 积分使用明细查询
export function fetchDistributerPointUsePage(data) {
  return request({
    url: `${BASE_URL}/use/page`,
    method: 'post',
    data
  })
}

// 积分统计查询
export function fetchDistributerPointStatistics(data) {
  return request({
    url: `${BASE_URL}/statistics`,
    method: 'post',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/integralManage/index.js